<template>
    <Dropdown
        :show="isOpen"
        horizonalPosition="left"
        verticalPosition="top"
        @click="isOpen = !isOpen"
    >
        <template #content>
            <div
                class="p-2 border border-gray-200 rounded-xl flex items-center gap-3"
            >
                <CountryFlag
                    class="size-4"
                    :locale="currentLocaleEnumData.key"
                />
                <span>{{ currentLocaleEnumData.nativeLanguageLabel }}</span>
                <Icon
                    name="angle-down"
                    class="w-3.5 h-3.5 text-gray-500"
                />
            </div>
        </template>
        <template #items>
            <a
                v-for="locale in LocaleEnumList"
                :href="getUrl(locale.key)"
            >
                <DropdownItem>
                    <div class="flex items-center gap-2">
                        <CountryFlag
                            class="size-4"
                            :locale="locale.key"
                        />
                        <span>{{ locale.nativeLanguageLabel }}</span>
                    </div>
                </DropdownItem>
            </a>
        </template>
    </Dropdown>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import Dropdown from '@/Shared/Component/Dropdown.vue'
    import DropdownItem from '@/Shared/Component/DropdownItem.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import useQueryParams from '@/Shared/Hook/useQueryParams'
    import CountryFlag from '@/Shared/Component/CountryFlag.vue'
    import {
        LocaleEnumList,
        type LocaleEnum,
        type LocaleEnumDataEntry,
    } from '@/Shared/AutoGenerated/LocalizationEnum'

    interface ProfileDropdownProps {
        currentLocaleEnumData: LocaleEnumDataEntry
    }

    const props = defineProps<ProfileDropdownProps>()
    const isOpen = ref<boolean>(false)

    const getUrl = (locale: LocaleEnum): string => {
        return useQueryParams().replace([{ key: 'locale', value: locale }])
    }
</script>
